import React from "react";
import "./loader.css";

const Loader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div className="app-loader-overlay">
      <div className="app-loader-card">
        <div className="app-loader-ring" />
        <p className="app-loader-text">
          Loading
          <span className="app-loader-dot">.</span>
          <span className="app-loader-dot">.</span>
          <span className="app-loader-dot">.</span>
        </p>
      </div>
    </div>
  );
};

export default Loader;
